// extracted by mini-css-extract-plugin
export var listEvents = "video-module--list-events--f6161";
export var logoContainer = "video-module--logo-container--d4314";
export var videoPlayer = "video-module--video-player--9fd6a";